module.exports = __webpack_public_path__ + "img/628.Cold_drinks_cups.16cf65ce.svg";